export default __webpack_public_path__ + "static/media/garoto.58140b34.png";